let searchMemberResult
const couponsInfo = []
const pendingApprovalCoupons = []
const outsideTheStoreApplicationTypeOptions = []

export default {
  searchMemberResult,
  couponsInfo,
  pendingApprovalCoupons,
  outsideTheStoreApplicationTypeOptions
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/store/state.js